module.exports = __webpack_public_path__ + "img/9.7b221f4f.jpg";